var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcTeamS2ArrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 99,
    viewBox: "0 0 81 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -14,
    y: -14,
    width: 109,
    height: 127
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7px)",
      clipPath: "url(#bgblur_0_398_2504_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 14
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 79,
    height: 97,
    rx: 39.5,
    transform: "matrix(-1 0 0 1 79 0)",
    fill: "url(#paint0_linear_398_2504)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 79,
    height: 97,
    rx: 39.5,
    transform: "matrix(-1 0 0 1 79 0)",
    stroke: "url(#paint1_linear_398_2504)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.678 58.922V54.34L36.686 49.7L49.678 45.06V40.478L30.77 47.438V51.962L49.678 58.922Z",
    fill: "url(#paint2_linear_398_2504)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_398_2504_clip_path",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 79,
    height: 97,
    rx: 39.5,
    transform: "matrix(-1 0 0 1 79 0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_2504",
    x1: 0,
    y1: 49.5,
    x2: 81,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502553,
    stopColor: "#0C081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_398_2504",
    x1: 0,
    y1: 49.5,
    x2: 81,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353365,
    stopColor: "#0B071B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.700997,
    stopColor: "#0B071B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_398_2504",
    x1: 51.3859,
    y1: 29,
    x2: 28.1651,
    y2: 29.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcTeamS2ArrowR);
export default __webpack_public_path__ + "static/media/tc_team_s2_arrow_r.3ea612c00742b2a8c12d4604f74cf3e0.svg";
export { ForwardRef as ReactComponent };